
import { Options, Vue } from 'vue-class-component'
import AuthorView from '@/components/Frontend/AuthorPosts/index.vue'

@Options({
  components: {
    AuthorView
  }
})
export default class AuthorPostsView extends Vue {}
